import { DirectusErrors, Location } from "./type";
import { fetchCollectionsDataPure, CollectionQuerys } from "@/lib/fetchData";
const API_HOST = process.env.NEXT_PUBLIC_API_HOST ?? "";

export default function createURL(url: string, params?: Record<string, any>) {
  if (!params) return API_HOST + url;

  return API_HOST + url + "?" + new URLSearchParams(params).toString();
}

// 处理接口返回值
export const handleJSONResponse = <T, E = DirectusErrors>(
  res: Response,
  errors?: E
): Promise<T> | Response | E => {
  if (res.headers.get("Content-Type")?.includes("application/json")) {
    return res.json() as Promise<T>;
  } else {
    if (errors) return errors;

    return res;
  }
};

export const getCountry = async (level: number = 1, parent?: number) => {
  const querys: CollectionQuerys = [{ key: "level", filter: { _eq: level } }];
  if (parent) {
    querys.push({ key: "parent", filter: { _eq: parent } });
  }
  return fetchCollectionsDataPure<Location>("location", {
    limit: 1000,
    page: 1,
    fields: ["*"],
    querys,
  });
};

export const createFormData = async (id: number, val: Record<string, any>) =>
  fetch(`${process.env.NEXT_PUBLIC_DATASERVER}/items/form_data`, {
    method: "POST",
    body: JSON.stringify({
      form: id,
      data: val,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((res) => res.json());
